module.exports = __webpack_public_path__ + "img/pickUpPoint.7f95c814.svg";